<h2 mat-dialog-title>
	{{ 'Log partecipante' | translate }}
	<small *ngIf="data.participantDescription"> — {{ data.participantDescription }}</small>
</h2>

<mat-dialog-content class="logs-dialog-content">

	<div class="loading-row" *ngIf="loading">
		<mat-spinner [diameter]="28"></mat-spinner>
	</div>

	<div class="error-row" *ngIf="error && !loading">
		{{ error | translate }}
	</div>

	<div class="empty-row" *ngIf="!loading && !error && logs.length === 0">
		{{ 'Nessun log disponibile' | translate }}
	</div>

	<ul class="logs-list" *ngIf="!loading && !error && logs.length > 0">
		<li class="log-item" *ngFor="let log of logs">
			<div class="log-meta">
				<span class="log-date">{{ log.created_at | date:'dd/MM/yyyy HH:mm:ss' }}</span>
				<span class="log-user" *ngIf="log.user_name || log.user_email">
					<span class="material-icons">person</span>
					{{ getUserLabel(log) }}
				</span>
				<span class="log-type" [attr.data-type]="log.log_type">{{ getLogTypeLabel(log.log_type) | translate }}</span>
			</div>
			<div class="log-message" *ngIf="log.user_message || log.message">
				{{ log.user_message || log.message }}
			</div>
			<div class="log-changes" *ngIf="getChangeSummary(log) as summary">
				{{ summary }}
			</div>
		</li>
	</ul>

</mat-dialog-content>

<mat-dialog-actions align="end">
	<button mat-button (click)="close()">{{ 'Chiudi' | translate }}</button>
</mat-dialog-actions>
